import React from "react";
import icons from "../helpers/icons";

const HelpIcon =(props)=>{
    const iconState = props.faqList.some(entry => entry.slug === props.slug && entry.body !== null );

    /*let iconState = false;
    props.faqList.entries.map(entry=>{
        if (entry.slug === props.slug && entry.body !==null){
            iconState = true;
        }
    })*/
    if (iconState){
        return <img className='helpIcon' src={icons.help} alt="Help" title={"hjelp"} onClick={(e) => {
            e.preventDefault();
            props.changeHelpRenderState(props.slug);
        }} />
    } else
        return null

}

export default HelpIcon